import { Injectable } from '@angular/core';
import { AESEncryptionService } from '@services/aes-encryption.service';

export enum LOCAL_STORAGE_KEY {
    ACCESS_TOKEN = 'accessToken',
    REFRESH_TOKEN = 'refreshToken',
    TEMP_TOKEN = 'tempToken',
    USER_ID = 'uid',
    PROFILE = 'profile',
    ROLE = 'role',
    PERMISSIONS = 'permission',
    IS_PASSWORD = 'isPassword',
    POSSIBLE_ROLES = 'possibleRoles',
    SELECTED_LANGUAGE = 'selectedLanguage',
    SELECT_ROLE = 'selectRole',
    PRESENTATIONS = 'presentations',
}

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    public localStorageKeyMap: Record<LOCAL_STORAGE_KEY, string> = {
        profile: '902229d4a48746109c66248898ed958p',
        accessToken: '7906f2f0736b4740aca043c2450e66c1',
        refreshToken: 'f3b841edabd14cd6a8bae4e4290b5eb2',
        tempToken: 'f878998285e94d24a95f4823338867e1',
        uid: '8c7337a370834c34ab6b5edbd094eddb',
        permission: 'bf80ccd7b0f64291b657ad4ffc845e47',
        isPassword: 'h4b841edabd14cd6a8bae4e4290b5eb1',
        role: 'bf80ccd7b0f64291b657ad4ffc845e59',
        possibleRoles: '802229d4a48746109c66248898ed958d',
        selectedLanguage: 'f6aecc766a9a4f2997b61a338f1f565a',
        selectRole: '9b145cba4a61471691bd5855513d6d65',
        presentations: 'jdfow73omf934wkalngf834hodim0xck',
    };

    constructor(private readonly encryptionService: AESEncryptionService) {}

    /**
     * Sets an item in local storage with encryption.
     * @param key - The key for the item to be stored.
     * @param value - The value to be stored, which will be encrypted.
     */
    setItem(key: LOCAL_STORAGE_KEY, value: string) {
        const localStorageKey = this.localStorageKeyMap[key];
        const encryptedData = this.encryptionService.encrypt(value);
        return localStorage.setItem(localStorageKey, encryptedData);
    }

    /**
     * Removes an item from local storage.
     * @param key - The key of the item to be removed.
     */
    removeItem(key: LOCAL_STORAGE_KEY) {
        const localStorageKey = this.localStorageKeyMap[key];
        return localStorage.removeItem(localStorageKey);
    }

    /**
     * Retrieves an item from local storage and decrypts it.
     * @param key - The key of the item to be retrieved.
     */
    getItem(key: LOCAL_STORAGE_KEY) {
        const localStorageKey = this.localStorageKeyMap[key];
        const value = localStorage.getItem(localStorageKey);
        if (!value) return null;
        return this.encryptionService.decrypt(value);
    }

    /**
     * Clears all items from local storage.
     */
    clearStorage() {
        return localStorage.clear();
    }
}
